import { useLinkAccount } from "@pages/me/hooks/useLinkAccount";
import { ModalHeader } from "./ModalHeader";
import { LinkAccountIllustration } from "@pages/me/LinkedAccount/LinkAccountIllustration";
import { ModalFooter } from "./ModalFooter";

interface ConnectTiktokAccountProps {
  onClose: () => void;
}

export const ConnectTiktokAccount = (props: ConnectTiktokAccountProps) => {
  const { onClose } = props;
  const go2Link = useLinkAccount();

  return (
    <div className="bg-kds-bg">
      <ModalHeader onClose={onClose} />
      <LinkAccountIllustration className="min-h-[592px]" onConnect={go2Link} loading={go2Link.isPending()} />
      <ModalFooter onCancel={onClose} disabledPost />
    </div>
  );
};
